<template>
   
    <ul class="transition-list">
        <transition-group 
            :css="false"
            mode="out-in"
            @after-enter="tilesResize"
            @before-enter="beforeEnter"
        >
            <li v-show="showLeftIf" key="left">
                <slot name="left" />
            </li>
            <li v-show="showRightIf" key="right">
                <slot name="right" />
            </li>
        </transition-group>
    </ul>
        
</template>

<script>
export default {
    props: {
        showLeftIf: {
            type: Boolean,
            default: true
        },
        showRightIf: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        isLeftLeave: false,
        isRightLeave: true
    }),
    methods: {
        tilesResize() {
            $('#tiles').trigger('resize') 
        },
        beforeEnter(el) {
            if(this.showLeftIf) {
                el.classList.add('left-enter')
            } else {
                el.classList.add('right-enter')
            }
        }
    }
}
</script>

<style lang="sass" scoped>
// .left-enter-active, .left-leave-active,
// .rigth-enter-active, .right-leave-active
//     transition: opacity 0.3s, transform 0.3s

// .left-enter-from, .left-leave-to
//     transform: translateX(-500px)
//     opacity: 0
// .left-enter-to, .left-leave-from
//     transform: translateX(0)
//     opacity: 1


// .rigth-enter-from, .rigth-leave-to
//     transform: translateX(500px)
//     opacity: 0
// .rigth-enter-to, .rigth-leave-from
//     transform: translateX(0)
//     opacity: 1

.transition-list
    margin: 0
    padding: 0

.left-enter
    animation: left 0.3s
.left-leave
    animation: left 0.3s reverse
.right-enter
    animation: rigth 0.3s
.rigth-leave
    animation: rigth 0.3s reverse

@keyframes left
    from
        transform: translateX(-500px)
        opacity: 0
    to
        transform: translateX(0)
        opacity: 1

@keyframes rigth
    from
        transform: translateX(500px)
        opacity: 0
    to
        transform: translateX(0)
        opacity: 1

</style>